export default "__VITE_ASSET__Bp6eJW7P__"